import CyberReview from './CyberReview';

export default CyberReview;
